import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "../api/axios";

export default function ProductCarousel({ title = "Products", category = null }) {
  const [products, setProducts] = useState([]);
  const [token] = localStorage.getItem("token") || "";
  const [getwishlist, setGetWishlist] = useState([]);
  const [quantities, setQuantities] = useState({}); // 👈 track quantities per product
  const navigate = useNavigate();


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const endpoint = category ? `/products?category=${category}` : "/products";
        const response = await axios.get(endpoint);
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, [category]);

  useEffect(() => {
    const initSwiper = () => {
      if (window.Swiper) {
        new window.Swiper(".products-carousel", {
          slidesPerView: 4,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: ".products-carousel-next",
            prevEl: ".products-carousel-prev",
          },
          breakpoints: {
            320: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          },
        });
      } else {
        setTimeout(initSwiper, 100);
      }
    };
    initSwiper();
  }, [products]);

const handleIncrease = (id) => {
  setQuantities((prev) => ({
    ...prev,
    [id]: (prev[id] || 1) + 1,  // 👈 fallback
  }));
};

const handleDecrease = (id) => {
  setQuantities((prev) => ({
    ...prev,
    [id]: Math.max(1, (prev[id] || 1) - 1),  // 👈 fallback
  }));
};

    const handleQuantityChange = (id, value) => {
    const num = parseInt(value, 10);
    if (!isNaN(num) && num > 0) {
      setQuantities((prev) => ({
        ...prev,
        [id]: num,
      }));
    }
  };
const handleAddToCart = (product, qty = 1) => {
  if (!token) {
    // Guest user → store in localStorage
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const existingIndex = cart.findIndex((item) => item.product_id === product.id);

    if (existingIndex >= 0) {
      cart[existingIndex].quantity += qty;
    } else {
      cart.push({
        product_id: product.id,
        name: product.name,
        price: product.price,
        quantity: qty,
        image: product.image_url,
      });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    alert("✅ Added to cart (Guest mode)!");
    window.location.reload();
    return;
  }

  // Logged-in user → backend API
  axios
    .post(
      "https://cartbackend.wsdstech.com/api/cart",
      { product_id: product.id, quantity: qty, price: product.price },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then(() => {
      alert("✅ Added to cart (Logged-in)!");
      window.location.reload();
    })
    .catch((err) => {
      alert("❌ Error: " + (err.response?.data?.message || "Something went wrong"));
    });
};



  useEffect(() => {
    if (token) {
      axios
        .get("https://cartbackend.wsdstech.com/api/wishlist", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const ids = res.data.map((item) => item.product_id);
          setGetWishlist(ids);
        })
        .catch((err) => console.error("Wishlist fetch error:", err));
    }
  }, [token]);

const handleToggleWishlist = async (productId) => {
  if (!token) {
    // Guest User: Store wishlist in localStorage
    let guestWishlist = JSON.parse(localStorage.getItem("guestWishlist")) || [];

    if (guestWishlist.includes(productId)) {
      // Remove from guest wishlist
      guestWishlist = guestWishlist.filter((id) => id !== productId);
    } else {
      // Add to guest wishlist
      guestWishlist.push(productId);
    }

    // Save back to localStorage
    localStorage.setItem("guestWishlist", JSON.stringify(guestWishlist));

    // Update state (so UI updates instantly)
    setGetWishlist(guestWishlist);
    return;
  }

  try {
    const response = await axios.post(
      "https://cartbackend.wsdstech.com/api/wishlist",
      { product_id: productId },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    // Update state with new wishlist
    setGetWishlist((prev) => [...prev, productId]);
  } catch (error) {
    console.error("Error toggling wishlist:", error);
  }
};



  return (
    <section className="py-5 overflow-hidden">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="section-header d-flex justify-content-between my-5">
              <h2 className="section-title">{title}</h2>
              <div className="d-flex align-items-center">
                <Link to="/all-products" className="btn-link text-decoration-none">View All Products →</Link>
                <div className="swiper-buttons">
                  <button className="swiper-prev products-carousel-prev btn btn-primary">❮</button>
                  <button className="swiper-next products-carousel-next btn btn-primary">❯</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="products-carousel swiper">
              <div className="swiper-wrapper">
                {products.map((product) => (
                  <div className="product-item swiper-slide" key={product.id}>
                    <Link
                      to="#"
                      className="btn-wishlist"
                      onClick={(e) => {
                        e.preventDefault();
                        handleToggleWishlist(product.id);
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      {getwishlist.includes(product.id) ? (
                        <i className="fa fa-solid fa-heart" style={{ color: "black" }}></i>
                      ) : (
                        <i className="fa fa-regular fa-heart"></i>
                      )}
                    </Link>
                    <figure>
                      <Link to={`/product/${product.id}`} title={product.name}>
                        <img
                          src={product.image_url}
                          className="tab-image"
                          alt={product.name}
                          style={{ objectFit: "cover", height: "200px", width: "100%" }}
                        />
                      </Link>
                    </figure>
                    <h3>{product.name}</h3>
                    <span className="qty">{product.quantity} Unit</span>
                    <span className="rating">
                      <i className='fa fa-solid fa-star fa-1xs ml-1' style={{color: '#FFC107'}}></i> 4.5
                    </span>
                    <span className="price">₹{product.price}</span>

                    <div className="d-flex align-items-center justify-content-between">
                       <div className="input-group product-qty">
                      <span className="input-group-btn">
                        <button
                          type="button"
                          className="quantity-left-minus btn btn-danger btn-number"
                          onClick={() => handleDecrease(product.id)}
                        >
                          <i className="fa fa-solid fa-minus fa-2xs"></i>
                        </button>
                      </span>
                      <input
                        type="text"
                        name="quantity"
                        className="form-control input-number text-center"
                        value={quantities[product.id] || 1}
                        onChange={(e) => handleQuantityChange(product.id, e.target.value)}
                      />
                      <span className="input-group-btn">
                        <button
                          type="button"
                          className="quantity-right-plus btn btn-success btn-number"
                          onClick={() => handleIncrease(product.id)}
                        >
                          <i className="fa fa-solid fa-plus fa-2xs"></i>
                        </button>
                      </span>
                    </div>
<Link
  to="#"
  onClick={() => handleAddToCart(product, quantities[product.id] || 1)}
  className="nav-link"
>
  Add to Cart <iconify-icon icon="uil:shopping-cart"></iconify-icon>
</Link>                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* / products-carousel */}
          </div>
        </div>
      </div>
    </section>
  );
}
